import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderThemeDirective } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { StorageNode } from '../storage-node'
import { StorageBrowseOptions } from '../storage-node-browser/storage-node-browse-options'
import { StorageNodeBrowserComponent } from '../storage-node-browser/storage-node-browser.component'

export class IStorageNodeSelectionDialogOptions {
  readonly storageBrowseOptions: StorageBrowseOptions
}

@Component({
  selector: 'app-storage-node-selection-dialog',
  templateUrl: './storage-node-selection-dialog.component.html',
  styleUrls: ['./storage-node-selection-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatIcon,
    MatButton,
    StorageNodeBrowserComponent,
    ElderTranslatePipe,
  ],
})
export class StorageNodeSelectionDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly options: StorageBrowseOptions
  public selectedNode: StorageNode
  private dialogRef = inject<MatDialogRef<StorageNodeSelectionDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IStorageNodeSelectionDialogOptions>(MAT_DIALOG_DATA)
    this.options = data?.storageBrowseOptions
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(node?: StorageNode): void {
    this.dialogRef.close(node)
  }
}
